Vue.component("flex-modal",
    {
        template: "#vue-flex-modal",

        computed: {
            totalFees()
            {
                const contract = this.getContractByType("proflex");
                const fees = contract && contract.data && contract.data.totals && contract.data.totals.fee;

                if (!fees)
                {
                    return null;
                }

                return Object.entries(fees).map(fee =>
                {
                    return {
                        min: fee[0],
                        fee: fee[1]
                    };
                });
            },

            orderFees()
            {
                const contract = this.getContractByType("proflex");

                const fees = contract && contract.data && contract.data.orders && contract.data.orders.fee;

                if (!fees)
                {
                    return null;
                }

                return Object.entries(fees).map(fee =>
                {
                    return {
                        min: fee[0],
                        fee: fee[1]
                    };
                });
            },

            contractCurrency()
            {
                const contract = this.getContractByType("proflex");

                return contract &&
                    contract.data &&
                    contract.data.price &&
                    contract.data.price.currency &&
                    contract.data.price.currency.name ||
                    null;
            },

            hasOrderPackages()
            {
                if (this.pid)
                {
                    const contract = this.$store.getters.getContractByPid(this.pid);

                    if (contract && contract.contractItemLists)
                    {
                        for (const list of Object.values(contract.contractItemLists))
                        {
                            for (const group in list)
                            {
                                if (group === "order.quantity")
                                {
                                    return true;
                                }
                            }
                        }
                    }

                }
                return false;
            },

            ...Vuex.mapGetters(
                {
                    getContractByType: "getPreparedContractByType",
                    trans: "getTranslation"
                }
            ),
            ...Vuex.mapState(
                {
                    pid: state => state.assistant.pid

                })

        },

        methods: {
            ...Vuex.mapMutations(
                [
                    "setAssistantModuleValue"
                ]
            ),

            selectVariant(module)
            {
                this.setAssistantModuleValue({
                    module,
                    value: 1
                });

                $("#proflexModal").modal("hide");
                this.$emit("nav-action", "next");
            }
        }

    });

